import _TaskService from "../services/task-service";
import { ITaskService } from "../types/services/task-service";

const TaskService: ITaskService = new _TaskService();

export default TaskService;
